import React, { Component } from 'react';

class Carregando extends Component {
    render () {
        return (
          
            <div className="well text-center"><b>Carregando...</b></div>
        )
    }
}

export default Carregando; 



// WEBPACK FOOTER //
// ./src/container/FlashCarregando.js